import { ERROR_MESSAGES } from "../../utils/exceptions";
export const getErrorValueResponse = (eResponse) => {
  if (
    eResponse.translated_error_message &&
    eResponse.translated_error_message.length > 0
  ) {
    return eResponse.translated_error_message;
  }
  const errorCode = eResponse?.error_code;
  return errorCode in ERROR_MESSAGES
    ? ERROR_MESSAGES[errorCode].MSG
    : ERROR_MESSAGES.DEFAULT.MSG;
};
